module.exports = __webpack_public_path__ + "static/media/logo.b65bdcaf.png";